(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-header.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-header.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const DRAW_CARD_TITLES = svs.components.tipsen.drawCard.constants.DRAW_CARD_TITLES;
const getIconBySportType = svs.components.tipsen.drawCard.utils.getIconBySportType;
const _svs$components$tipse = svs.components.tipsen.drawSelector.constants,
  DRAW_SORT_FLOW = _svs$components$tipse.DRAW_SORT_FLOW,
  DRAW_SORT_QS = _svs$components$tipse.DRAW_SORT_QS,
  DRAW_FILTER_QS = _svs$components$tipse.DRAW_FILTER_QS;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  Button = _svs$ui.ReactButton,
  IconButton = _svs$ui.ReactIconButton;
const SportTypeToString = svs.components.sport.sportTypes.SportTypeToString;
const productIds = svs.utils.products.productIds;
const getDefaultSortFlow = productId => {
  switch (productId) {
    case productIds.MATCHEN:
      return DRAW_SORT_FLOW.NET_SALE.value;
    default:
      return DRAW_SORT_FLOW.REG_CLOSE_TIME.value;
  }
};
const DrawSelectorHeader = _ref => {
  let hasExtraMoneyValue = _ref.hasExtraMoneyValue,
    onToggleFunc = _ref.onToggleFunc,
    blockClassName = _ref.blockClassName,
    _ref$sportTypes = _ref.sportTypes,
    sportTypes = _ref$sportTypes === void 0 ? [] : _ref$sportTypes,
    _ref$shouldDisableTit = _ref.shouldDisableTitle,
    shouldDisableTitle = _ref$shouldDisableTit === void 0 ? false : _ref$shouldDisableTit,
    productId = _ref.productId;
  const history = useHistory();
  const qs = new URLSearchParams(history.location.search);

  sportTypes.sort();
  const handleOnSelect = event => {
    const sortFlow = event.target.value;
    if (qs.get(DRAW_SORT_QS) === sortFlow || Boolean(!hasExtraMoneyValue && sortFlow === DRAW_SORT_FLOW.EXTRA_MONEY.value)) {
      return;
    }
    qs.set(DRAW_SORT_QS, sortFlow);
    history.replace("".concat(history.location.pathname, "?").concat(qs.toString()));
  };
  const handleFilterClick = sportTypeValue => {
    const filterValues = qs.getAll(DRAW_FILTER_QS);
    const sport = SportTypeToString[sportTypeValue];
    const isSportTypeFiltered = filterValues.includes(sport);
    if (isSportTypeFiltered) {
      filterValues.splice(filterValues.indexOf(sport), 1);
    } else {
      filterValues.push(sport);
    }
    qs.delete(DRAW_FILTER_QS);
    if (filterValues.length) {
      filterValues.forEach(value => {
        qs.append(DRAW_FILTER_QS, value);
      });
    }
    history.replace("".concat(history.location.pathname, "?").concat(qs.toString()));
  };
  const defaultSortFlow = getDefaultSortFlow(productId);
  const selectedSortFlow = qs.get(DRAW_SORT_QS) || defaultSortFlow;
  const shouldRenderSportTypesFilter = sportTypes.length > 1;
  const filteredValues = qs.getAll(DRAW_FILTER_QS);
  const dropDownSortValues = Object.values(DRAW_SORT_FLOW);
  return React.createElement("div", {
    className: "pg_draw_selector__header",
    role: "rowgroup"
  }, React.createElement("div", {
    className: "".concat(blockClassName, "__headers"),
    role: "row"
  }, !shouldDisableTitle && React.createElement("div", {
    className: "".concat(blockClassName, "__headers_title")
  }, "V\xE4lj spelomg\xE5ng"), React.createElement("div", {
    className: "".concat(blockClassName, "__sort_container")
  }, React.createElement(Form, null, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    "aria-label": "Sortera omg\xE5ngar",
    onChange: handleOnSelect,
    value: selectedSortFlow
  }, dropDownSortValues.map(sortFlow => React.createElement(Option, {
    "aria-label": sortFlow.title,
    disabled: Boolean(sortFlow.title === DRAW_CARD_TITLES.EXTRA_MONEY && !hasExtraMoneyValue),
    key: sortFlow.value,
    name: sortFlow.value,
    value: sortFlow.value
  }, sortFlow.title)))))), shouldRenderSportTypesFilter && React.createElement("div", {
    className: "".concat(blockClassName, "__filter_container")
  }, sportTypes.map(sportType => {
    const isChecked = filteredValues.includes(SportTypeToString[sportType]);
    return React.createElement(IconButton, {
      "aria-label": SportTypeToString[sportType],
      className: "".concat(blockClassName, "__filter_icon_button ").concat(isChecked ? "".concat(blockClassName, "__filter_icon_button_checked") : ''),
      key: sportType,
      onClick: () => handleFilterClick(sportType),
      size: 400
    }, React.createElement(Icon, {
      color: isChecked ? 'icon-inverted' : '',
      icon: getIconBySportType(sportType)
    }));
  })), onToggleFunc && React.createElement(Button, {
    "aria-label": "St\xE4ng omg\xE5ngsv\xE4ljare",
    className: "".concat(blockClassName, "__headers__button"),
    iconPosition: "center",
    onClick: onToggleFunc,
    size: 400,
    transparent: true
  }, React.createElement(Icon, {
    icon: "close"
  }))));
};
setGlobal('svs.components.tipsen.drawSelector.DrawSelectorHeader', DrawSelectorHeader);

 })(window);